export enum SAVE_QUOTE_CARD_TYPE {
  DEFAULT_QUOTE_REFERRAL = "defaultQuoteReferral",
  DOCUMENT_UPLOAD_REQUEST = "documentUploadRequest"
}
export interface SavedQuotesInputs {
  TQuoteType: SAVE_QUOTE_CARD_TYPE.DEFAULT_QUOTE_REFERRAL | SAVE_QUOTE_CARD_TYPE.DOCUMENT_UPLOAD_REQUEST;
}

export enum SAVE_QUOTE_EXACT_TARGET_EMAILTYPEPREFERENCE {
  EMAIL_REFERRAL = 'EMAILREFERRAL',
  DOCUMENT_UPLOAD_REQUEST = 'DOCUMENTUPLOAD'
}

export interface SaveQuoteCardDeleteQuoteEvent { 
  id: string, 
  name: string, 
  showAlert: boolean 
}
